export default {
  verboseName: "Stanza",
  verboseNamePlural: "Stanze",
  modelName: "Room",
  modelNamePlural: "Rooms",
  appName: "hotels",
  propName: "room",
  propNamePlural: "rooms",
}
